document.addEventListener("DOMContentLoaded", function () {
  const inputs = document.querySelectorAll(".search_input_custom");
  const typingSpeed = 80;
  const pauseTime = 2000;

  async function typeWriter(el, text) {
    while (true) {
      // Type text
      for (let i = 1; i <= text.length; i++) {
        el.placeholder = text.substring(0, i);
        await new Promise(r => setTimeout(r, typingSpeed));
      }

      // Pause after typing
      await new Promise(r => setTimeout(r, pauseTime));

      // Erase text
      for (let i = text.length; i >= 0; i--) {
        el.placeholder = text.substring(0, i);
        await new Promise(r => setTimeout(r, typingSpeed / 2));
      }

      // Pause before restart
      await new Promise(r => setTimeout(r, 800));
    }
  }

  inputs.forEach(input => {
    const text = input.getAttribute("placeholder");
    if (text) {
      typeWriter(input, text);
    }
  });
});
